import Vue from 'vue'
import Router from 'vue-router'
import mobile from "is-mobile"

Vue.use(Router)

import Vuex from "vuex"
Vue.use(Vuex);
import storeObj from "../store"
const store = new Vuex.Store(storeObj)


let mobileRoutes = [
  {
    path: "/mobile/passCard",
    name: "passCard",
    meta: {
      header: false,
      header_home_btn: false,
      need_auth: true,
      mobile: true,
    },
    component: resolve => require(["../components/mobile/passCard.vue"], resolve)
  },
  {
    path: "/mobile/mobileEventList",
    name: "mobileEventList",
    meta: {
      header: false,
      header_home_btn: false,
      need_auth: true,
      mobile: true,
    },
    component: resolve => require(["../components/mobile/mobileEventList.vue"], resolve)
  },
  {
    path: "/mobile/me",
    name: "me",
    meta: {
      header: false,
      header_home_btn: false,
      need_auth: true,
      mobile: true,
    },
    component: resolve => require(["../components/mobile/myHome.vue"], resolve)
  },
  {
    path: "/mobile/mySport",
    name: "mySport",
    meta: {
      header: false,
      header_home_btn: false,
      need_auth: true,
      mobile: true
    },
    component: resolve => require(["../components/mobile/mySport.vue"], resolve)
  },
  {
    path: "/mobile/sportEventList",
    name: "sportEventList",
    meta: {
      header: false,
      header_home_btn: false,
      need_auth: true,
      mobile: true
    },
    component: resolve => require(["../components/mobile/sportEventList.vue"], resolve)
  },
  {
    path: "/mobile/sportRegister",
    name: "sportRegister",
    meta: {
      header: false,
      header_home_btn: false,
      need_auth: true,
      mobile: true
    },
    component: resolve => require(["../components/mobile/sportRegister.vue"], resolve)
  },
  {
    path: "/mobile/sportDetail",
    name: "sportDetail",
    meta: {
      header: false,
      header_home_btn: false,
      need_auth: true,
      mobile: true
    },
    component: resolve => require(["../components/mobile/sportDetail.vue"], resolve)
  },
  {
    path: "/mobile/wonderfulMoments",
    name: "wonderfulMoments",
    meta: {
      header: false,
      header_home_btn: false,
      need_auth: true,
      mobile: true
    },
    component: resolve => require(["../components/mobile/wonderfulMoments.vue"], resolve)
  },
  {
    path: "/mobile/mobileSessionList/:event_id",
    name: "mobileSessionList",
    meta: {
      header: false,
      header_home_btn: false,
      need_auth: true,
      mobile: true,
    },
    component: resolve => require(["../components/mobile/mobileSessionList.vue"], resolve)
  }

]
const router = new Router({
  mode: "history",
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: "/",
      name: "Login",
      alias: "/Login",
      meta: {
        header: false,
        header_home_btn: false,
        need_auth: false,
        mobile: true,
      },
      component: resolve => require(["../views/login.vue"], resolve)
    },
    // {
    //   path: "/speakerChatroom/login",
    //   name: "speakerChatroomLogin",
    //   meta: {
    //     header: false,
    //     header_home_btn: false,
    //     need_auth: false,
    //     mobile: false,
    //   },
    //   component: resolve => require(["../views/speakerChatroom/login"], resolve)
    // },
    {
      path: "/pdf",
      name: "pdf",
      meta: {
        header: false,
        header_home_btn: false,
        need_auth: false,
        mobile: false,
      },
      component: resolve => require(["../views/pdf"], resolve)
    },
    {
      path: "/BroadcastPreview",
      name: "BroadcastPreview",
      meta: {
        header: false,
        header_home_btn: false,
        need_auth: false,
        mobile: false,
      },
      component: resolve => require(["../views/speakerChatroom/index"], resolve)
    },
    {
      path: "/HostSessions",
      name: "HostSessions",
      meta: {
        header: true,
        header_home_btn: true,
        need_auth: true,
        mobile: false,
      },
      component: resolve => require(["../views/host_sessions.vue"], resolve)
    },
    {
      path: "/EventList",
      name: "EventList",
      meta: {
        header: true,
        header_home_btn: false,
        need_auth: true,
        mobile: false,
      },
      component: resolve => require(["../views/event_list.vue"], resolve)
    },
    {
      path: "/IpadCenter",
      name: "IpadCenter",
      meta: {
        header: true,
        header_home_btn: false,
        need_auth: false,
        mobile: false,
      },
      component: resolve => require(["../views/ipadPush/ipad_center.vue"], resolve)
    },
    {
      path: "/EvtDetail/:event_id",
      name: "EvtDetail",
      meta: {
        header: true,
        header_home_btn: true,
        need_auth: false,
        mobile: true,
        is_role: true
      },
      component: resolve => require(["../views/ipadPush/evt_detail.vue"], resolve)
    },
    {
      path: "/AssetFrame/:session_id",
      name: "AssetFrame",
      meta: {
        header: true,
        header_home_btn: true,
        need_auth: false,
        mobile: false,
      },
      component: resolve => require(["../views/ipadPush/asset_frame.vue"], resolve)
    },
    {
      path: "/EventDetail/:event_id",
      name: "EventDetail",
      meta: {
        header: true,
        header_home_btn: true,
        need_auth: true,
        mobile: false,
        is_role: true
      },
      component: resolve => require(["../views/event_detail.vue"], resolve)
    },
    {
      path: "/assistantMenu/:event_id",
      name: "AssistantMenu",
      meta: {
        header: true,
        header_home_btn: true,
        need_auth: true,
        mobile: false,
      },
      component: resolve => require(["../views/assistant_menu.vue"], resolve)
    },
    {
      path: "/Meeting/:session_id",
      name: "Meeting",
      meta: {
        header: false,
        header_home_btn: false,
        need_auth: true,
        mobile: false,
      },
      component: resolve => require(["../views/meeting.vue"], resolve)
    },
    {
      path: "/Session/:session_id",
      name: "Session",
      meta: {
        header: true,
        header_home_btn: true,
        need_auth: true,
        mobile: false,
      },
      component: resolve => require(["../views/session.vue"], resolve)
    },
    {
      path: "/SessionReport/:session_id/:channel_id",
      name: "SessionReport",
      meta: {
        header: true,
        header_home_btn: true,
        need_auth: true,
        mobile: false,
      },
      component: resolve => require(["../views/session_report.vue"], resolve)
    },
    {
      path: "/SessionReport/:channel_id",
      name: "SessionReport",
      meta: {
        header: true,
        header_home_btn: true,
        need_auth: true,
        mobile: false,
      },
      component: resolve => require(["../views/session_report.vue"], resolve)
    },
    {
      path: "/Session",
      name: "Session2",
      redirect: "/Session/0"
    },
    // {
    //   path: "/ZoomClient/:session_id",
    //   name: "ZoomClient",
    //   component: resolve => require(["../views/zoom_client.vue"], resolve)
    // },
    {
      path: "/Leave",
      name: "Leave",
      meta: {
        header: true,
        header_home_btn: true,
        need_auth: true,
        mobile: false,
      },
      component: resolve => require(["../views/leave.vue"], resolve)
    },
    {
      path: "/invitation",
      name: "invitation_none",
      meta: {
        header: false,
        header_home_btn: false,
        need_auth: false,
        mobile: true,
      },
      component: resolve => require(["../views/invitation.vue"], resolve)
    },
    {
      path: "/invitation/:event_id",
      name: "invitation",
      meta: {
        header: false,
        header_home_btn: false,
        need_auth: false,
        mobile: true,
      },
      component: resolve => require(["../views/invitation.vue"], resolve)
    },
    {
      path: "/Register",
      name: "Register",
      meta: {
        header: false,
        header_home_btn: false,
        need_auth: true,
        mobile: true,
      },
      component: resolve => require(["../views/register.vue"], resolve)
    },
    {
      path: "/RoleSwitch/:event_id",
      name: "RoleSwitch",
      meta: {
        header: true,
        header_home_btn: true,
        need_auth: true,
        mobile: false,
      },
      component: resolve => require(["../views/role_switch.vue"], resolve)
    },
    {
      path: "/EventQa/:event_id",
      name: "EventQa",
      meta: {
        header: true,
        header_home_btn: true,
        need_auth: true,
        mobile: false,
      },
      component: resolve => require(["../views/event_qa.vue"], resolve)
    },
    {
      path: "/Broadcast/CountDown",
      name: "Broadcast_CountDown",
      meta: {
        header: false,
        header_home_btn: false,
        need_auth: false,
        mobile: false,
      },
      component: resolve => require(["../views/broadcast/count_down.vue"], resolve)
    },
    {
      path: "/Broadcast/Thanks",
      name: "Broadcast_Thanks",
      meta: {
        header: false,
        header_home_btn: false,
        need_auth: false,
        mobile: false,
      },
      component: resolve => require(["../views/broadcast/thanks.vue"], resolve)
    },
    {
      path: "/Broadcast/Blank",
      name: "Broadcast_Blank",
      meta: {
        header: false,
        header_home_btn: false,
        need_auth: false,
        mobile: false,
      },
      component: resolve => require(["../views/broadcast/blank.vue"], resolve)
    },
    {
      path: "/Privacy",
      name: "Privacy",
      meta: {
        header: false,
        header_home_btn: false,
        need_auth: false,
        mobile: true,
      },
      component: resolve => require(["../views/privacy.vue"], resolve)
    },
    {
      path: "/InvitationList/:event_id",
      name: "InvitationList",
      meta: {
        header: true,
        header_home_btn: true,
        need_auth: true,
        mobile: false,
      },
      component: resolve => require(["../views/invitation_list.vue"], resolve)
    },
    {
      path: "/ApprovalList/:event_id/:invitation_code",
      name: "ApprovalList",
      meta: {
        header: true,
        header_home_btn: true,
        need_auth: true,
        mobile: false,
      },
      component: resolve => require(["../views/approval_list.vue"], resolve)
    },
    {
      path: "/ChannelList",
      name: "ChannelList",
      meta: {
        header: true,
        header_home_btn: true,
        need_auth: true,
        mobile: false,
      },
      component: resolve => require(["../views/channel_list.vue"], resolve)
    },
    {
      path: "/Support",
      name: "Support",
      meta: {
        header: false,
        header_home_btn: false,
        need_auth: false,
        mobile: true,
      },
      component: resolve => require(["../views/support.vue"], resolve)
    },
    {
      path: "/Media",
      name: "Media",
      meta: {
        header: false,
        header_home_btn: false,
        need_auth: true,
        mobile: false,
      },
      component: resolve => require(["../views/media.vue"], resolve)
    },
    {
      path: "/Activity/:session_id",
      name: "ActivityMedia",
      meta: {
        header: true,
        header_home_btn: true,
        need_auth: true,
        mobile: false,
      },
      component: resolve => require(["../views/activity.vue"], resolve)
    },
    {
      path: "/Broadcast/pause",
      name: "Broadcast_Pause",
      meta: {
        header: false,
        header_home_btn: false,
        need_auth: false,
        mobile: false,
      },
      component: resolve => require(["../views/broadcast/pause.vue"], resolve)
    },
    ...mobileRoutes
  ]
})

//给公共参数重新赋值
if (hgetStore("hvuex")) {
  store.dispatch("hvuex", JSON.parse(hgetStore("hvuex")));
}
//方便修改
export async function hvuex(obj) {
  return store.dispatch("hvuex", obj);
}
window.hvuex = hvuex;

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
originalReplace.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
router.beforeEach((to, from, next) => {
  let session_key = store.getters.kls_user_session;
  // if (to.name == 'speakerChatroom') {
  //   hvuex({ classNum: 10202218, userName: parseInt(Math.random() * 1000000) })
  // }
  // return;
  let test_mobile = mobile()
  if (test_mobile == true && to.meta.mobile == false) {
    location.href = "/Support"
    return
  }
  //
  if (to.meta.need_auth == true && (session_key == null || session_key == undefined)) {
    // console.log(store.state.user_info, "store.state.user_info")
    // return
    if (to.name == "Media") {
      localStorage.setItem("back_url", to.fullPath)
    }
    location.href = "/"
    // if (to.params.is_login == true) {
    //   // location.href = "/"
    //   next()
    //   return;
    // } else {
    //   location.href = "/"
    // }

  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js